import PropTypes from "prop-types";
import React from "react";

export const ArrowRightIcon = ({ height, width, ...props }) => {
    return (
        <svg
            fill="currentColor"
            viewBox="0 0 16 16"
            height={height || "1em"}
            width={width || "1em"}
            {...props}
        >
            <path
                fillRule="evenodd"
                d="M1 8a.5.5 0 01.5-.5h11.793l-3.147-3.146a.5.5 0 01.708-.708l4 4a.5.5 0 010 .708l-4 4a.5.5 0 01-.708-.708L13.293 8.5H1.5A.5.5 0 011 8z"
            />
        </svg>
    );
};

ArrowRightIcon.propTypes = {
    width: PropTypes.number,
    height: PropTypes.number
};
